import axios, { AxiosResponse } from "axios";
import { backendApi, backendApiDemo } from "../../../common/apiService";
import { ConceptualMap, ImageData, MapData } from "./reducers";

export const mapsServices = {
    getSingleConceptualMap,
    updateSingleConceptualMap,
	requestUploadUrlImage,
	s3ImageUpload,
	getOneImage,
	deleteDrawing
};

export function updateSingleConceptualMap(map_id: string, token: string,study_session_id:string,content:{}) {
	return new Promise<ConceptualMap>(async (resolve, reject) => {
		let conceptual_map_obj: ConceptualMap;
		if (map_id) {
			backendApi
				.patch(`/resources/maps/${map_id}`, 
                    {   
                        content: content, // Map JSON here
                        study_session_id: study_session_id,
                    },{
                        headers: {
                            Authorization: `Bearer ${token}`,
                        }
                    }
                    
                )
				.then((response) => {
					if (response.status === 200) {
                        console.log("[updateSingleConceptualMap]update Successful:", response.status);
						conceptual_map_obj = response.data.content;
						resolve(conceptual_map_obj);
					} else {
						reject(new Error(`[updateSingleConceptualMap]Request failed with status ${response.status}`));
					}
				})
				.catch((error) => {
					console.error(`[updateSingleConceptualMap]Error updating  conceptual map: ${map_id}}`, error);
					reject(error);
				});
		}
	});
}

export function getMaps(token: string) {
	return new Promise<ConceptualMap[]>(async (resolve, reject) => {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
		let conceptual_map_obj: ConceptualMap[];
		backendApi
			.get(`/resources/maps/`, config)
			.then((response) => {
				if (response.status === 200) {
                    console.log("[getMaps]Fetch Successful:", response.status);
					conceptual_map_obj = response.data.content;
					resolve(conceptual_map_obj);
				} else {
					reject(new Error(`[getMaps]Request failed with status ${response.status}`));
				}
			})
			.catch((error) => {
				console.error(`[getMaps]Error fetching conceptual maps`, error);
				reject(error);
			});
	});
}
export function getSingleConceptualMap(map_id: string, token: string) {
	return new Promise<ConceptualMap>(async (resolve, reject) => {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		};
		let conceptual_map_obj: ConceptualMap;
		if (map_id) {
			backendApi
				.get(`/resources/maps/${map_id}`, config)
				.then((response) => {
					if (response.status === 200) {
                        console.log("[getSingleConceptualMap]Fetch Successful:", response.status);
						conceptual_map_obj = response.data;
						resolve(conceptual_map_obj);
					} else {
						reject(new Error(`[getSingleConceptualMap]Request failed with status ${response.status}`));
					}
				})
				.catch((error) => {
					console.error(`[getSingleConceptualMap]Error fetching single conceptual map: ${map_id}}`, error);
					reject(error);
				});
		}
	});
}

 async function requestUploadUrlImage(user_id:string,token:string,text:string,file_type:string){
    return new Promise<ImageData>(async (resolve, reject) => {
        console.log(user_id,token,text)
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
        const bodyData = {
            word: text,
			file_type:file_type
          };
        backendApi
            .post(`/users/${user_id}/images`, bodyData,config)
            .then((response) => {
                console.log(response)
                if (response.status === 200) {
                    console.log("[requestUploadUrlDrawing]Upload successful")
                    
                    resolve(response.data);
                }
               
                else {
                    reject(new Error(`[requestUploadUrlDrawing]Request failed with status ${response.status}`));
                }
            })
            .catch((error) => {
                if(error.status === 409) {
                    console.log(("[requestUploadUrlDrawing]Drawing exists, updating..."))
                    resolve(error.status)
                }else{
                console.error(`[requestUploadUrlDrawing]Error generating upload url`, error);
                reject(error);
            }
            });
    });
}
 async function s3ImageUpload(file:File | Blob,s3Link:string){
console.warn(s3Link)
const formData = new FormData();

// Append the file or Blob to the FormData instance
formData.append('file', file);

try {
    // Perform the HTTP POST request to upload the file
    const response: AxiosResponse = await axios.put(s3Link, file,{
        headers:{
            'Content-Type':file.type
        }
    });
    return response.status===200
} catch (error) {
    // Handle errors
    if (axios.isAxiosError(error)) {
        // TO DO: DELETE DOCUMENT IF ERROR HAPPENS USING THE DOCUMENT ID 
        console.error('Error uploading file:', error.response?.data || error.message);
    } else {
        console.error('Unexpected error:', error);
    }
    return false
}
}

 async function getOneImage(user_id:string,token:string,text:string){
        return new Promise<any>(async (resolve, reject) => {
            // console.log(user_id,token,text)
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            };

            backendApi
                .get(`/users/${user_id}/images/${text}`,config)
                .then((response) => {
                    console.log(response)
                    if (response.status === 200) {
                        console.log("[getOneDrawing]Url generation successful")
                        
                        resolve(response.data);
                    } else {
                        reject(new Error(`[getOneDrawing]Request failed with status ${response.status}`));
                    }
                })
                .catch((error) => {
                    if(error.status===404){
                        console.log("[getOneDrawing]No Drawing for this word yet")
                        resolve(false)
                    }else{
                        console.error(`[getOneDrawing]Error generating url`, error);
                        reject(error);
                    }
                });
        });

}
async function deleteDrawing(user_id:string,token:string,text:string){
	return new Promise<ImageData>(async (resolve, reject) => {
		// console.log(user_id,token,text)
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
			}
		};
		backendApi
			.delete(`/users/${user_id}/images/${text}`,config)
			.then((response) => {
				console.log(response)
				if (response.status === 200) {
					console.log("[requestPatchUrlDrawing]Delete successful")
					
					resolve(response.data);
				}
			   
				else {
					reject(new Error(`[requestPatchUrlDrawing]Deletion failed with statu ${response.status}`));
				}
			})
			.catch((error) => {

				console.error(`[requestPatchUrlDrawing]Error Deleting image`, error);
				reject(error);
			
			});
	});
}